// Fun facts and lies about Kevin Rassner
// These will be randomly selected for the "2 Truths, 1 Lie" section

interface FunFact {
  text: {
    en: string;
    de: string;
  };
  isLie: boolean;
}

export const funFacts: FunFact[] = [
  // Truths
  {
    text: {
      en: "I performed in a play at the Badisches Staatstheater.",
      de: "Ich habe eine Spielzeit im Badischen Staatstheater gespielt"
    },
    isLie: false
  },
  {
    text: {
      en: "I was homeless for two weeks and lived on $3 a day.",
      de: "Ich war zwei Wochen obdachlos und habe von 3 Dollar am Tag gelebt"
    },
    isLie: false
  },
  {
    text: {
      en: "I shook hands with the Danish royal couple.",
      de: "Ich habe dem dänischen Königspaar die Hand geschüttelt"
    },
    isLie: false
  },
  {
    text: {
      en: "I am an honorary citizen of a small American town.",
      de: "Ich bin Ehrenbürger einer amerikanischen Kleinstadt"
    },
    isLie: false
  },
  {
    text: {
      en: "I broke my first bone at the age of 38.",
      de: "Mit 38 habe ich mir mit 38 meinen ersten Knochen gebrochen"
    },
    isLie: false
  },
  {
    text: {
      en: "I had to take the practical driving test four times.",
      de: "Die praktische Führerscheinprüfung durfte ich vier mal machen."
    },
    isLie: false
  },
  {
    text: {
      en: "I built this website with the help of 5 different AIs.",
      de: "Diese Webseite habe ich mithilfe von 5 verschiedenen AIs gebaut."
    },
    isLie: false
  },
  {
    text: {
      en: "This is the first website I've ever programmed.",
      de: "Das ist die erste Webseite die ich je programmiert habe."
    },
    isLie: false
  },
  {
    text: {
      en: "A Hollywood celebrity once tried to kiss me but I didn't want to.",
      de: "Ein Hollywood-Promi hat mal versucht mich zu küssen aber ich wollte nicht."
    },
    isLie: false
  },
  {
    text: {
      en: "I was once threatened with guns by the Mexican drug cartel.",
      de: "Ich wurde mal vom mexikanischen Drogenkartell mit Gewehren bedroht."
    },
    isLie: false
  },
  {
    text: {
      en: "I went on a road trip with a cage fighter I met on the internet.",
      de: "Ich habe einen Roadtrip mit einem mir unbekannten Käfigkämpfer aus dem Internet gemacht."
    },
    isLie: false
  },
  {
    text: {
      en: "I almost started a baker's apprenticeship in Canada.",
      de: "Ich hätte beinahe in Kanada eine Bäckerausbildung angefangen."
    },
    isLie: false
  },
  // Lies
  {
    text: {
      en: "My mother named me after 'Home Alone' (Kevin).",
      de: "Meine Mutter hat mich nach 'Kevin allein zuhause' benannt"
    },
    isLie: true
  },
  {
    text: {
      en: "I once made it to the K2 base camp.",
      de: "Ich bin mal bis zum K2 Basislager gekommen"
    },
    isLie: true
  },
  {
    text: {
      en: "I was trained as a kitchen assistant in an Indian monastery.",
      de: "Ich wurde in einem indischen Kloster zum Hilfskoch ausgebildet."
    },
    isLie: true
  },
  {
    text: {
      en: "I once randomly sat next to Elon Musk in a restaurant.",
      de: "Ich habe einmal in einem Restaurant zufällig neben Elon Musk gesessen."
    },
    isLie: true
  },
  {
    text: {
      en: "I tutored an NBA player in German.",
      de: "Ich habe einem NBA-Spieler Nachhilfe in Deutsch gegeben."
    },
    isLie: true
  },
  {
    text: {
      en: "I once accidentally interrupted a marriage proposal on a TV show.",
      de: "Ich habe einmal versehentlich einen Heiratsantrag in einer TV-Show unterbrochen."
    },
    isLie: true
  }
];

// Function to get random facts (2 truths and 1 lie)
export const getRandomFacts = (language: 'en' | 'de'): { text: string; isLie: boolean }[] => {
  // Separate truths and lies
  const truths = funFacts.filter(fact => !fact.isLie);
  const lies = funFacts.filter(fact => fact.isLie);
  
  // Randomly select 2 truths and 1 lie
  const selectedTruths = [...truths]
    .sort(() => 0.5 - Math.random())
    .slice(0, 2)
    .map(fact => ({
      text: fact.text[language],
      isLie: false
    }));
  
  const selectedLie = {
    text: lies[Math.floor(Math.random() * lies.length)].text[language],
    isLie: true
  };
  
  // Combine and shuffle the results
  const result = [...selectedTruths, selectedLie]
    .sort(() => 0.5 - Math.random());
  
  return result;
};
